// Tiny shared helper: a player is considered "set up" once they pick an avatar
// (preset or custom/AI) so league owners can identify them at a glance.
export function isProfileComplete(user) {
  if (!user) return false;
  return (user.avatar_id !== null && user.avatar_id !== undefined) || !!user.pfp_url;
}
